import { useCanPerformContentOperation } from '@confluence/entity-operations/entry-points/entityOperationsHelpers.ts';
import { OperationTypes } from '@confluence/entity-operations/entry-points/operationsTypes.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

/**
 * Whether the user can review suggestions while the content is in view mode, on a published page or a live doc.
 *
 * @param contentId - The content id. Pass undefined when the caller isn't eligible for Review.
 * @param contentType - The content type, used to check edit permission.
 */
export const useCanReviewInViewMode = (
	contentId: string | undefined,
	contentType: string | null | undefined,
): boolean => {
	const canUpdateContent = useCanPerformContentOperation({
		contentId: contentId ?? '',
		contentType: contentType === 'blogpost' ? 'blogpost' : 'page',
		operation: OperationTypes.UPDATE,
	});

	return (
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning -- The suggested edits experiment is the kill switch for the view mode Suggestions panel subgate.
		!!contentId &&
		!!canUpdateContent &&
		expValEquals('platform_editor_ai_content_suggested_edits', 'isEnabled', true) &&
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- View mode Suggestions panel subgate.
		fg('confluence_suggestions_panel_view_mode')
	);
};
